module.exports = __webpack_public_path__ + "static/img/3.ebdafbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/3.png
// module id = WddF
// module chunks = 1